import { useEffect, useState } from "react";
import {
  ORG_ENTITLEMENTS_UPDATED_EVENT,
  persistOrgEnabledServicesFromLogin,
  storeOrgEnabledServices,
} from "./orgEnabledServices";

export { ORG_ENTITLEMENTS_UPDATED_EVENT };

export function useOrgEntitlementsRevision() {
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const onUpdate = () => setRevision((n) => n + 1);
    window.addEventListener(ORG_ENTITLEMENTS_UPDATED_EVENT, onUpdate);
    return () => window.removeEventListener(ORG_ENTITLEMENTS_UPDATED_EVENT, onUpdate);
  }, []);
  return revision;
}

/** Apply entitlements from login, handoff, user payload, or entitlements API. */
export function applyOrgEntitlementsPayload(portal, data) {
  const raw = data?.enabledServices ?? data?.enabled_services;
  if (!Array.isArray(raw)) return false;
  storeOrgEnabledServices(portal, raw);
  window.dispatchEvent(new CustomEvent(ORG_ENTITLEMENTS_UPDATED_EVENT, { detail: { portal } }));
  return true;
}

export async function refreshOrgEntitlementsFromApi({ portal, apiBase, hqFetch }) {
  const fetcher = hqFetch || fetch;
  const res = await fetcher(`${apiBase}/organization/entitlements`, { credentials: "include" });
  if (!res.ok) return false;
  const data = await res.json().catch(() => ({}));
  return applyOrgEntitlementsPayload(portal, data);
}

export function syncOrgEntitlementsFromSession(portal, session) {
  persistOrgEnabledServicesFromLogin(portal, session);
  window.dispatchEvent(new CustomEvent(ORG_ENTITLEMENTS_UPDATED_EVENT, { detail: { portal } }));
}
